module.exports = __webpack_public_path__ + "assets/img/driver-btn-e4a8a255.png";